import Home from "./Pages/Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainLayout from "./Layouts/MainLayout";
import Error from "../../Components/Error";
import ScrollToTop from "../../utils/ScrollToTop";
import Error404 from "../../Components/Error404";
import Weblog from "./Pages/Weblog";
import Post from "./Pages/Post";
import ShopApp from "../../Shop/ShopApp";
import Single from "../../Shop/Pages/Single";

export default function Theme4(){
    return(
        <BrowserRouter>
            <ScrollToTop/>
            <Routes>
                <Route path="/" element={<MainLayout />} errorElement={<Error />}>
                    <Route index element={<Home />} />
                    <Route path="blog" element={<Weblog />} />
                    <Route path="post/:id/:name?" element={<Post />} />
                    
                    <Route path="shop">
                        <Route index element={<ShopApp />} />
                        {/* <Route path=":catId" element={<ShopCat />} /> */}
                        <Route path="*" element={<Error404 />} />
                    </Route>
                    <Route path="product/:id/:name?" element={<Single />}/>  
                    
                    <Route path="*" element={<Error404 />} />
                </Route>
            </Routes>
        </BrowserRouter>
    )
}